export default __webpack_public_path__ + "static/media/addFolderButton.2bf8e7b4.svg";